import { Divider, Flex, Heading } from "@sidelinesports/fan-design-system";
import { useOrdinalFormatter } from "../../../../hooks/use-ordinal-formatter.ts";
import { pluralize } from "../../../../utils/pluralize.ts";
import { useCurrentScoringAndRank } from "../../hooks";
import styles from "./RundownStats.module.css";

export const RundownStats = () => {
  const scoringAndRankQuery = useCurrentScoringAndRank();

  const points = scoringAndRankQuery.data?.rank?.points;
  const rank = scoringAndRankQuery.data?.rank?.rank;

  return (
    <Flex gap={24} align="center" justify="center">
      <Statistic label={pluralize(points ?? 0, "Point")} value={points} />
      <Divider className={styles.divider} direction="vertical" size="auto" />
      <Statistic label="Rank" value={rank} format="ordinal" />
    </Flex>
  );
};

const Statistic = ({
  label,
  value,
  format = "cardinal",
}: {
  label: string;
  value: string | number | undefined | null;
  format?: "ordinal" | "cardinal";
}) => {
  const toOrdinal = useOrdinalFormatter();
  const toNumericString =
    format === "ordinal" ? toOrdinal : (x: number) => x.toLocaleString();

  const valueAsString =
    value === undefined || value === null
      ? "—"
      : typeof value === "number"
        ? toNumericString(value)
        : value;

  return (
    <Flex
      className={styles.statistic}
      direction="column"
      align="center"
      gap={8}
    >
      <div className={styles.value}>{valueAsString}</div>
      <Heading level={6} className={styles.label} color="readable-on-dark">
        {label}
      </Heading>
    </Flex>
  );
};
